import ApiBase from './ApiBase';
import axios from 'axios';

/**
 * Fund-Investor Tags Associations API
 */
class FundInvestorTagsAssociationsApi extends ApiBase {
  /**
   * create fundinvestortags/associations relations
   * @param {*} ids List of fundTagId/fundId-investorId
   */
  async create(payload) {
    const request = {
      url: `${this.API_URL}/fundinvestortags/associations`,
      headers: this.getHeaders(),
      method: 'POST',
      data: payload
    };

    const response = await axios.request(request);

    return response.data;
  }

  /**
   * delete fundinvestortags/associations relations
   * @param {*} ids List of fundTagId/fundId-investorId
   */
  async delete(payload) {
    const request = {
      url: `${this.API_URL}/fundinvestortags/associations`,
      headers: this.getHeaders(),
      method: 'DELETE',
      data: payload
    };

    const response = await axios.request(request);

    return response.data;
  }
}

export default new FundInvestorTagsAssociationsApi();
